<template>
  <div class="wrap-box">
    <div class="view-title">
      <p class="title">{{words.DataSurvey}}</p>
      <div class="date-box" @click="showDateModel(0)">
        <img :src="arrow_bottom" alt class="icon" />
        <p class="text">{{Overview.page.start}} - {{Overview.page.end}}</p>
      </div>
    </div>
    <div class="circle-box">
      <div class="item">
        <div class="item-content">
          <i-Circle :percent="Overview.percent[0]" stroke-color="#b558f6" :size="99">
            <div class="triangle_border_down"></div>
          </i-Circle>
          <div class="data-box">
            <p class="number">{{Overview.data.copy_total_pages}}</p>
            <p class="text">{{words.Copy_page}}</p>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-content">
          <i-Circle :percent="Overview.percent[1]" stroke-color="#b558f6" :size="99">
            <div class="triangle_border_down"></div>
          </i-Circle>
          <div class="data-box">
            <p class="number">{{Overview.data.print_total_pages}}</p>
            <p class="text">{{words.Print_page}}</p>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-content">
          <i-Circle :percent="Overview.percent[2]" stroke-color="#b558f6" :size="99">
            <div class="triangle_border_down"></div>
          </i-Circle>
          <div class="data-box">
            <p class="number">{{Overview.data.scan_total_pages}}</p>
            <p class="text">{{words.Scan_page}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="Trend">
        <div class="view-title">
          <p class="title">{{words.ConsumptionRrend}}</p>
          <div class="date-box" @click="showDateModel(1)">
            <img :src="arrow_bottom" alt class="icon" />
            <p class="text">{{trend.page.start}} - {{trend.page.end}}</p>
          </div>
        </div>
        <div class="echarts" ref="echarts"></div>
      </div>
      <div class="right">
        <div class="view-title">
          <p class="title">{{words.Consumptionratio}}</p>
          <div class="date-box" @click="showDateModel(2)">
            <img :src="arrow_bottom" alt class="icon" />
            <p class="text">{{Proportion.page.start}} - {{Proportion.page.end}}</p>
          </div>
        </div>
        <div class="echarts" ref="rightEcharts"></div>
      </div>
    </div>

    <Modal v-model="dateModel" title="请选择开始和结束时间" @on-ok="dateOK" @on-cancel="dateCancel">
      <div style="padding:20px;">
        <DatePicker
          type="month"
          placeholder="请选择开始时间"
          style="width: 200px"
          @on-change="startDateOk"
        ></DatePicker>
        <DatePicker
          type="month"
          placeholder="请选择结束时间"
          style="width: 200px;margin-left:20px;"
          @on-change="endDateOk"
        ></DatePicker>
      </div>
    </Modal>

    <Modal
      v-model="setPasswordModel"
      title="修改密码"
      @on-ok="dateOK"
      @on-cancel="dateCancel"
      :closable="false"
      :mask-closable="false"
    >
      <div style="padding:20px;">
        <p class="title" style="margin-bottom:20px;">为了您的账户安全，请修改初始密码</p>
        <Input
          v-model="password"
          placeholder="请输入6-16位数字和字母"
          type="password"
          style="width: 100%;height:45px;"
          size="large"
          :readonly="passwordLoading"
          autocomplete="off"
        />
      </div>
      <div slot="footer">
        <Button type="primary" :loading="passwordLoading" @click="SavePassword">确认修改</Button>
      </div>
    </Modal>
    <Modal v-model="userSetPasswordModel" title="修改密码" @on-ok="dateOK" @on-cancel="dateCancel">
      <div style="padding:20px;">
        <p class="title" style="margin-bottom:20px;">为了您的账户安全，请设置登录密码</p>
        <Input
          v-model="password"
          placeholder="请输入6-16位数字和字母"
          type="password"
          style="width: 100%;height:45px;"
          size="large"
          :readonly="passwordLoading"
          autocomplete="new-password"
        />
      </div>
      <div slot="footer">
        <Button type="primary" :loading="passwordLoading" @click="SavePassword">确认修改</Button>
        <Button @click="userSetPasswordModel = false">跳过</Button>
      </div>
    </Modal>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>


<script>
import { mapGetters, mapActions } from "vuex";
import echarts from "echarts";
export default {
  data() {
    return {
      arrow_bottom: require("../../assets/arrow_bottom.png"),
      percent: 50,
      color: "#2db7f5",
      //时间选择器
      dateModel: false,
      type: 0,
      start_date: "",
      end_date: "",
      //折线图
      echartsOption: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["费用", "印张"]
        },
        grid: {
          left: "0",
          right: "1%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "费用",
            type: "line",
            stack: "总量",
            data: [],
            smooth: true
          },
          {
            name: "印张",
            type: "line",
            stack: "总量",
            data: [],
            smooth: true
          }
        ]
      },

      //饼图
      PercentageEcharts: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          x: "center",
          y: "bottom"
        },
        toolbox: {
          show: true
        },
        series: [
          {
            name: "详情",
            type: "pie",
            radius: [20, 110],
            roseType: "radius",
            data: []
          }
        ]
      },
      Overview: {
        page: {
          start: "",
          end: ""
        },
        data: {
          print_total_pages: 0,
          copy_total_pages: 0,
          scan_total_pages: 0
        },
        percent: [0, 0, 0]
      },
      trend: {
        page: {
          start: "",
          end: ""
        }
      },
      Proportion: {
        page: {
          start: "",
          end: ""
        }
      },
      setPasswordModel: false,
      password: "",
      passwordLoading: false,
      userSetPasswordModel: false
    };
  },
  mounted() {
    this.GetUserInfo().then(res => {
      this.setUser(res.data);
      if (this.user.setPassword && this.user.is_staff)
        this.setPasswordModel = true;
      else if (!this.user.is_staff && !this.user.pass)
        this.userSetPasswordModel = true;
    });

    this.init();
  },
  methods: {
    ...mapActions([
      "GetUserOverview",
      "GetUserTrend",
      "GetUserPro",
      "SetUserInfo",
      "GetUserInfo",
      "setUser"
    ]),
    setEcharts() {
      this.echartsOption.legend.data = [
        this.words.Home_Page,
        this.words.Home_Cost
      ];
      this.echartsOption.series[0].name = this.words.Home_Cost;
      this.echartsOption.series[1].name = this.words.Home_Page;
      let barBox = echarts.init(this.$refs.echarts, "light");
      barBox.setOption(this.echartsOption, true);
    },
    Percentage() {
      let barBox = echarts.init(this.$refs.rightEcharts, "light");
      barBox.setOption(this.PercentageEcharts, true);
    },
    dateOK() {
      if (this.type === 0) {
        this.UserOverview();
      }
      if (this.type === 1) {
        this.trendData();
      }
      if (this.type === 2) {
        this.trendData();
      }
    },
    dateCancel() {
      this.dateModel = false;
    },
    startDateOk(e) {
      console.log("startDateOk", e);
      if (this.type === 0) {
        this.Overview.page.start = e;
      }
      if (this.type === 1) {
        this.trend.page.start = e;
      }
      if (this.type === 2) {
        this.Proportion.page.start = e;
      }
    },
    endDateOk(e) {
      console.log("endDateOk", e);
      if (this.type === 0) {
        this.Overview.page.end = e;
      }
      if (this.type === 1) {
        this.trend.page.end = e;
      }
      if (this.type === 2) {
        this.Proportion.page.end = e;
      }
    },
    showDateModel(type) {
      this.type = type;
      if (type === 0) {
        this.start_date = this.Overview.page.start;
        this.end_date = this.Overview.page.end;
      }
      if (type === 1) {
        this.start_date = this.trend.page.start;
        this.end_date = this.trend.page.end;
      }
      if (type === 2) {
        this.start_date = this.Proportion.page.start;
        this.end_date = this.Proportion.page.end;
      }
      this.dateModel = true;
    },
    init() {
      this.Overview.page = {
        start: this.$momentDate(new Date().setMonth(0), "YYYY.MM"),
        end: this.$momentDate(new Date().setDate(), "YYYY.MM")
      };

      this.trend.page = {
        start: this.$momentDate(new Date().setMonth(0), "YYYY.MM"),
        end: this.$momentDate(new Date().setDate(), "YYYY.MM")
      };

      this.Proportion.page = {
        start: this.$momentDate(new Date().setMonth(0), "YYYY.MM"),
        end: this.$momentDate(new Date().setDate(), "YYYY.MM")
      };

      this.UserOverview();
      this.trendData();
      this.UserPro();
    },
    UserOverview() {
      this.GetUserOverview(this.Overview.page).then(res => {
        this.Overview.data = res.data;
        this.Overview.percent[0] = res.data.copy_total_pages / 1000;
        this.Overview.percent[1] = res.data.print_total_pages / 1000;
        this.Overview.percent[2] = res.data.scan_total_pages / 1000;
      });
    },
    trendData() {
      let data = {
        start: this.trend.page.start,
        end: this.trend.page.end + ".31"
      };
      this.GetUserTrend(data).then(res => {
        this.echartsOption.xAxis.data = res.data.dateArray;
        this.echartsOption.series[1].data = res.data.pageArray;
        this.echartsOption.series[0].data = res.data.moneyArray;
        // this.echartsOption.series[1].data[this.echartsOption.series[1].data.length - 1] = 2
        // console.log(JSON.stringify(this.echartsOption))
        this.setEcharts();
      });
    },
    UserPro() {
      this.GetUserPro(this.Proportion.page).then(res => {
        if (!this.lang) {
          res.data.total[0].name = this.words.print;
          res.data.total[1].name = this.words.Home_Copy;
          res.data.total[2].name = this.words.Home_scan;
        }
        this.PercentageEcharts.series[0].data = res.data.total;
        this.Percentage();
      });
    },
    SavePassword() {
      if (!this.password) {
        this.$Message.error("请输入密码");
        return false;
      }
      if (this.password.length < 6) {
        this.$Message.error("密码不得少于6位");
        return false;
      }
      this.passwordLoading = true;
      this.SetUserInfo({
        password: this.password
      }).then(res => {
        this.passwordLoading = false;
        if (res.code) {
          this.user.setPassword = false;
          this.setPasswordModel = false;
          this.userSetPasswordModel = false;
          this.$Message.success("密码修改成功");
          this.GetUserInfo().then(res => {
            res.data.token = this.user.token;
            this.setUser(res.data);
          });
        } else {
          this.$Message.error(res.msg || "密码修改失败");
        }
      });
    }
  },
  computed: mapGetters({
    words: "words",
    user: "user",
    lang: "lang"
  })
};
</script>
